import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Constants from "@constants/Constants";
import Dialog from "@genie-ui/react/Dialog";
import Button from "@genie-ui/react/v2/Button";
import Typography from "@genie-ui/react/v2/Typography";
import { resetUseCaseAssessments } from "@store/slices/useCaseAssessments.slice";
import { deleteImportedTemplate } from "@store/slices/uploadUseCases.slice";

import "./ImportUseCasesProgressModal.scss";

const { 
  HEADER, DESCRIPTION, NO_CTA, YES_CTA
} = Constants.IMPORT_USE_CASES.TASK_IN_PROGRESS_MODAL;

const ImportUseCasesProgressModal = (props) => {
  const { showModal, handleCancelLeave, handleConfirmLeave } = props;
  const dispatch = useDispatch();
  const { scorecardData } = useSelector((state) => state.scorecard);
  const { id: scorecardId = '' } = scorecardData || {};
  const { useCasesInfo } = useSelector((state) => state.uploadUseCases);

  const onNoButtonClick = () => {
    handleCancelLeave();
  }

  const onYesButtonClick = () => {
    dispatch(resetUseCaseAssessments());
    dispatch(deleteImportedTemplate({ scorecardId: scorecardId, importId: useCasesInfo?.importId }))
    handleConfirmLeave();
  }

  const renderFooter = () => (
    <div className="mercury-importUseCasesProgressModal__footer">
      <Button
        variant="ghost"
        onClick={onNoButtonClick}
        className="mercury-importUseCasesProgressModal__footer--noBtn"
      >
        <Typography variant="subtitle1" size="xs" fontWeight="semibold">
          {NO_CTA}
        </Typography>
      </Button>
      <Button
        variant="primary"
        onClick={onYesButtonClick}
        className="mercury-importUseCasesProgressModal__footer--yesBtn"
      >
        <Typography variant="subtitle1" size="xs" fontWeight="semibold">
          {YES_CTA}
         </Typography>
      </Button>
    </div>
  )

  const getTitleNode = () => (
    <Typography 
      variant="subtitle1" size="sm" fontWeight="semibold"
      className="mercury-importUseCasesProgressModal__title"
    >
      {HEADER}
    </Typography>
  )

  return (
    <Dialog
      titleNode={getTitleNode()}
      classNameRoot="mercury-importUseCasesProgressModal__root"
      className="mercury-importUseCasesProgressModal"
      open={showModal}
      onClose={onNoButtonClick}
      footerNode={renderFooter()}
    >
      <Typography variant="body1" className="mercury-importUseCasesProgressModal__desc">
        {DESCRIPTION}
      </Typography>
    </Dialog>
  );
}

export default ImportUseCasesProgressModal;
